import { create } from 'zustand';
import { ShipmentBox } from 'common/src/utils/types';

export type ShipmentRecord = ShipmentBox & {
  estimated_settlement_date?: Date | '';
  status?: 'settled' | 'pending';
  ship_destination_country?: string | null;
  ship_destination_port?: string | null;
};

type ShipmentsStore = {
  shipments: ShipmentRecord[];
  loading: boolean;
  error: string | null;
  setShipments: (
    shipments:
      | ShipmentRecord[]
      | ((previousShipments: ShipmentRecord[]) => ShipmentRecord[])
  ) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearShipments: () => void;
};

const useShipmentsStore = create<ShipmentsStore>((set) => ({
  shipments: [],
  loading: true,
  error: null,
  setShipments: (shipments) =>
    set((state) => ({
      shipments:
        typeof shipments === 'function'
          ? shipments(state.shipments)
          : shipments,
    })),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearShipments: () => set({ shipments: [], error: null }),
}));

export default useShipmentsStore;
